import React, {useState} from 'react'
import {Localizer} from 'infrastructure/localization/localizer'
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {HttpClientService} from "../../../../services/httpClient/httpClientService";
import {AccountService} from "../../../../services/account/accountService";
import {LogbogUddannelsesplanApi} from "../../../../services/api/logbogUddannelsesplan/logbogUddannelsesplanApi";
import {setSlideinState, SlideInStateEnum} from "../../../../core/components/slideIn/slideInSlice";
import {HandleError} from "../../../../core/infrastructure/errors/errorBoundary";
import {Form, Formik} from "formik";
import {UddannelsesplanCrudFields} from "./uddannelsesplanCrudFields";
import {
    ValidationFormSubmitButton
} from "../../../../core/components/validation/components/validationFormButton";
import {CrudUddannelsesplanInputModel, crudUddannelsesplanValidationSchema} from "./crudUddannelsesplanInputModel";
import {forloebReducer, ForloebSliceState} from "../../../../core/forloebSlice";
import {ReactFileUploaderFile} from "../../../../core/components/fileUpload/reactFileUploader";
import {FileMetadata} from "../../../../core/sharedmodels/fileMetaData/fileMetaData";
import {NotatType} from "../../../../core/sharedmodels/notat/notatType";
import {LogbogNotatApi} from "../../../../services/api/logbogNotat/logbogNotatApi";
import {BuildNewCrudNotatModel} from "../../../../core/sharedmodels/notat/notatCrudModel";
import InfoText from './infoText';
import {ModalAcceptType} from 'core/components/modalMessage/modalSubmitMessage';
import {nameof} from 'ts-simple-nameof';
import useUser from 'core/hooks/useUser';


interface CreateUdannelsesplanProps {
    modalId: string,
}

const uddannelsesplanApi = new LogbogUddannelsesplanApi(new HttpClientService(), new AccountService())
const notatApi = new LogbogNotatApi(new HttpClientService(), new AccountService())

export function CreateUddannelsesplan(props: CreateUdannelsesplanProps) {
    const dispatch = useAppDispatch();
    const forloebSliceState = useAppSelector(forloebReducer) as ForloebSliceState;
    const {currentUser} = useUser();
    const showTilfoejOgKlarmeldButton = (currentUser.IsAdmin() || currentUser.IsLaege());

    const createUddannelsesplan = async (inputModel: CrudUddannelsesplanInputModel) => {
        dispatch(setSlideinState({state: SlideInStateEnum.ActionOngoing, slideInId: props.modalId}))
        let uddannelsesplanId = await uddannelsesplanApi.createUddannelsesplan(inputModel);

        if (uploadedFilesState?.length > 0) {
            let notat = BuildNewCrudNotatModel([uddannelsesplanId], NotatType.Uddannelsesplan, forloebSliceState.forloebState.brugerId);
            await notatApi.createNotat(notat, uploadedFilesState.map(tf => tf.fileMetadata.id));
        }

        dispatch(setSlideinState({state: SlideInStateEnum.Closing, slideInId: props.modalId}))
    }

    const [uploadedFilesState, setUploadedFilesState] = useState<ReactFileUploaderFile[]>([]);

    const fileUploadedCallback = async (uploadedFiles: ReactFileUploaderFile[]) => {
        setUploadedFilesState(arr => [...arr, ...uploadedFiles]);
    }

    const fileDeletedCallback = (fileMetaData: FileMetadata) => {
        let updatedFileUploadedState = [...uploadedFilesState];
        let deleteIndex = updatedFileUploadedState.findIndex(file => file.fileMetadata.id === fileMetaData.id);
        updatedFileUploadedState.splice(deleteIndex, 1);
        setUploadedFilesState(updatedFileUploadedState);
    }

    const render = (
        <Formik
            initialValues={new CrudUddannelsesplanInputModel(forloebSliceState.forloebState.id)}
            validationSchema={crudUddannelsesplanValidationSchema}
            onSubmit={async (values: CrudUddannelsesplanInputModel) => {
                await createUddannelsesplan(values)
                    .catch(err => { // catch is needed to handle unhandeled exception (eg. api offline). Formik onsubmithandler is catching all exception and writing them as warnings
                        dispatch(setSlideinState({state: SlideInStateEnum.Opened, slideInId: props.modalId}))
                        HandleError(err);
                    });
            }}>
            {
                (formik) => (
                    <Form>
                        <UddannelsesplanCrudFields
                            modalId={props.modalId}
                            formik={formik}
                            fileUploadedCallback={fileUploadedCallback}
                            fileDeletedCallback={fileDeletedCallback}
                        />

                        <InfoText text={Localizer.forloebpage_uddannelsesplanInfo()}/>

                        <div className="modal-actions d-flex flex-row wrap">
                            {showTilfoejOgKlarmeldButton &&
                                <ValidationFormSubmitButton
                                    formikProps={formik}
                                    buttonType={ModalAcceptType.default}
                                    onClickSubmitOverride={() => {
                                        formik.setFieldValue(nameof<CrudUddannelsesplanInputModel>(x => x.klarmeldtAt), new Date());
                                        formik.handleSubmit()
                                    }}>
                                    {Localizer.uddannelsesplan_createAndKlarmeldUddannelsesplan()}
                                </ValidationFormSubmitButton>
                            }
                            <ValidationFormSubmitButton formikProps={formik}>
                                {Localizer.uddannelsesplan_createUddannelsesplan()}
                            </ValidationFormSubmitButton>
                        </div>

                    </Form>
                )
            }
        </Formik>
    )
    return <>{render}</>
}
